import sizzlinSummer from '../../images/campaigns/sizzlinSummer/pool.jpg';
import bonusTokens from '../../images/campaigns/bonusTokens/50free-tokenmodal.jpg';
import vDay from '../../images/campaigns/vDay/Token-Overlay.jpg';
import stPatricksCountDownBanner from '../../images/campaigns/stPatricks/st_patricks_dir_banner_timer.jpg';
import shamrock from '../../images/campaigns/stPatricks/clover.png';
import stPatricksTokenOverlay from '../../images/campaigns/stPatricks/token-overlay-960x146.png';
import happyHourTokenOverlay from '../../images/campaigns/happyHour/cam4_happy_hour_token-overlay.jpg';
import happyHourIconL from '../../images/campaigns/happyHour/left.png';
import happyHourIconR from '../../images/campaigns/happyHour/right.png';
import easter2020TokenOverlay from '../../images/campaigns/easter2020/token-overlay.jpg';
import easter2020IconL from '../../images/campaigns/easter2020/left.png';
import easter2020IconR from '../../images/campaigns/easter2020/right.png';


export const BONUS_TOKENS = 'BONUS_TOKENS';
export const MOBILE_OVERLAY_CTA = 'MOBILE_OVERLAY_CTA';

const CAMPAIGNS = {
  SIZZLIN_SUMMER_TOKEN_PROMO_2019: {
    banner: sizzlinSummer,
    title: 'payment.summer.sale',
    subtitle: 'epay.epay.bonus.tokens.percent.gold',
    bonusPercent: '10',
  },
  BONUS_TOKENS: {
    banner: bonusTokens,
    title: 'epay.epay.bonus.tokens.amount',
    subtitle: 'epay.epay.with.first.purchase',
  },
  VALENTINES_2020: {
    banner: vDay,
    title: 'epay.epay.campaign.valentines.tokensCta',
    titlePlaceholders: {
      0: '<strong>',
      1: '</strong>',
    },
    subtitle: 'epay.epay.campaign.valentines.membersTokens',
    subtitlePlaceholders: {
      0: '5%',
      1: '10%',
    },
    bonusPercent: '10',
    bonusPercentBasic: '5',
    showGoldBonusIncentive: true,
  },

  STPATRICKS_DAY_2020: {
    banner: stPatricksTokenOverlay,
    title: 'gold.gold.stPatricks.day.title',
    subtitle: 'gold.gold.stPatricks.day.copy',
    bonusPercent: '10',
    bonusPercentBasic: '5',
    countDownTimer: {
      id: 'stPatricksCampaign',
      show: true,
      banner: {
        text: 'banner.banner.get.up.to',
        placeholders: { 0: '10%' },
        body: '',
        imageLink: stPatricksCountDownBanner,
        triggerTokensModal: true,
        class: 'stPatricks',
        iconImage: {
          url: shamrock,
          name: 'shamrock',
        },
      },
    },
  },

  HAPPY_HOUR: {
    banner: happyHourTokenOverlay,
    title: 'gold.gold.happyHour.tokenOverlay.title',
    subtitle: 'gold.gold.happyHour.tokenOverlay.copy',
    showGoldBonusIncentive: true,
    countDownTimer: {
      id: 'happyHourCampaign',
      wrapperClass: 'noBcgImageWrapper',
      show: true,
      banner: {
        text: 'gold.gold.happyHour.tokenOverlay.title',
        body: 'gold.gold.happyHour.bannerBody.copy',
        bodyPlaceholders: { 0: '10' },
        imageLink: false,
        triggerTokensModal: true,
        class: 'happyHour',
        iconImage: {
          urlLeft: happyHourIconL,
          urlRight: happyHourIconR,
          name: 'happyHourIcon',
        },
      },
    },
  },

  EASTER_2020: {
    banner: easter2020TokenOverlay,
    title: 'campaigns.easter2020.global.title',
    subtitle: 'campaigns.easter2020.tokenOverlay.body',
    showGoldBonusIncentive: true,
    countDownTimer: {
      id: 'easter2020Campaign',
      wrapperClass: 'noBcgImageWrapper',
      show: true,
      banner: {
        text: 'campaigns.easter2020.timer.title',
        body: 'campaigns.easter2020.timer.body',
        bodyPlaceholders: { 0: '10' },
        imageLink: false,
        triggerTokensModal: true,
        class: 'easter2020',
        iconImage: {
          urlLeft: easter2020IconL,
          urlRight: easter2020IconR,
          name: 'easter2020Icon',
        },
      },
    },
  },
};

export default CAMPAIGNS;
